import { render, staticRenderFns } from "./spot-page.vue?vue&type=template&id=6381ab46&scoped=true&"
import script from "./spot-page.vue?vue&type=script&lang=js&"
export * from "./spot-page.vue?vue&type=script&lang=js&"
import style0 from "./spot-page.vue?vue&type=style&index=0&id=6381ab46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6381ab46",
  null
  
)

export default component.exports